<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox">
            <el-form-item label="创建时间:">
              <el-date-picker
                v-model="createTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="货源状态:">
              <el-select v-model="searchFrom.orderState" placeholder="请选择">
                <el-option label="全部" value="" ></el-option>
                <el-option label="已停用" value="0" ></el-option>
                <el-option label="生效中" value="1" ></el-option>
                <el-option label="已结束" value="2" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="货物类型:" >
                <el-select  v-model="searchFrom.productTypeName" filterable placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in HWlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="货源编号:">
              <el-input placeholder="" v-model="searchFrom.orderNo"></el-input>
            </el-form-item>
            <el-form-item label="客户名称:">
              <el-input placeholder="" v-model.trim="searchFrom.payee"></el-input>
            </el-form-item>
            <el-form-item label="指派司机:">
              <el-input placeholder="" v-model.trim="searchFrom.driverName"></el-input>
            </el-form-item>
            <el-form-item label="发货地址:">
              <el-input placeholder="" v-model.trim="searchFrom.deliverAddress"></el-input>
            </el-form-item>
            <el-form-item label="收货地址:">
              <el-input placeholder="" v-model.trim="searchFrom.receivingAddress"></el-input>
            </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item >
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addFn" v-if="btnFlg[2]">新增</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="delFn" v-if="btnFlg[0]">删除</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="finishFn" v-if="btnFlg[1]">结束</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="zhipaiFn" v-if="btnFlg[7]">指派司机</el-button>
          </el-form-item>
          <el-button type="primary" size="mini" v-if="btnFlg[8]" :disabled="isDisable" @click="daochuFN">导出</el-button>
        </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="tableList" v-loading="loading" bordersize="mini"  class="tableComent" @selection-change='selectGoods' @row-click="handleRowClick"  height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" v-if="scope.row.orderSource==5 && btnFlg[3]" @click="modifyFn(scope.row)">编辑</el-button>
              <el-button type="text" size="mini" v-if="scope.row.pickAlreadyNum >0 && btnFlg[6]" @click="wayFn(scope.row)">运单</el-button>
              <el-button type="text" size="mini" v-if="scope.row.orderState!=1 && btnFlg[4]" @click="qiTingFN(scope.row,1)">启用</el-button>
              <el-button type="text" size="mini" v-if="scope.row.orderState==1 && btnFlg[5]" @click="qiTingFN(scope.row,2)">停用</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="二维码" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="lookFN(scope.row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" label="货源编号" width="230">
          <!-- <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.orderNo}}</span>
          </template> -->
        </el-table-column>
        <el-table-column prop="payee" label="客户名称" width="230" :formatter="emptyFn" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="orderStateName" label="货源状态" width="100">
        </el-table-column>
        <el-table-column prop="pickTotalNum" label="摘单次数" width="100" :formatter="emptyFn" ></el-table-column>
        <el-table-column prop="pickAlreadyNum" label="已用次数" width="100" :formatter="emptyFn" >
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="numberFn(scope.row)">{{scope.row.pickAlreadyNum}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pickRemainNum" label="剩余次数" width="100" :formatter="emptyFn" ></el-table-column>
        <el-table-column prop="productTypeName" label="货物类型" width="150" :formatter="emptyFn" ></el-table-column>
        <el-table-column prop="orderWeight" label="单车货源量" width="120" >
          <template slot-scope="scope">
            <span>{{scope.row.orderWeight}}{{scope.row.measuringUnit}}</span>
          </template>
        </el-table-column>
        <el-table-column label="发货信息" width="450" >
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#017426">(发){{scope.row.deliverPerson}}</span><span>{{scope.row.deliverPhone}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.deliverAddress}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收货信息" width="450" >
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#F56C6C">(收){{scope.row.receivingPerson}}</span><span>{{scope.row.receivingPhone}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.receivingAddress}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="driverNum" label="司机数量" width="100" :formatter="emptyFn" >
          <template slot-scope="scope">
            <span class="textColer" @click="driverNumFn(scope.row)">{{scope.row.driverNum}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createUser" label="创建人" width="170"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="dateTimeFormat" width="170"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog title="货源码" :visible.sync="seeQuXiaoClick" width="500px"   :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <div class="imgBox" style="margin-left: 110px;">
        <qriously :value="initQCode" :size="250" />
      </div>
      <div style="font-size:18px;" >
        <div style="">
          <span style="font-weight:600;">发布企业：</span><span>{{qrCodeInfo.createSubcompanyName}}</span>
        </div>
        <div style="">
          <span style="font-weight:600;">发货地：</span><span>{{qrCodeInfo.deliverAddress}}</span>
        </div>
        <div style="">
          <span style="font-weight:600;">收货地：</span><span>{{qrCodeInfo.receivingAddress}}</span>
        </div>
        <div style="">
          <span style="font-weight:600;">货物类型：</span><span>{{qrCodeInfo.productTypeName}}</span>
        </div>
      </div>
      <!-- <div style="font-size:18px;color:red;">
        <span>注意：</span><span>请司机上传有效证件</span>
      </div> -->
      <div style="font-size:18px;color:red;">
        <span>请扫描正确货源码，否则影响运费结算</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="seeQuXiaoClick = false" >关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="已用详情" :close-on-click-modal="false" :close-on-press-escape="false"  :visible.sync="isEdit" @close="closeDialog" width="750px" center>
      <div>
        <el-form :inline="true" :model="SJsearchFrom" ref="SJsearchFrom" class="demo-form-inline" label-width="100px" size="mini">
          <div class="inpBox">
            <el-form-item label="司机姓名:">
              <el-input placeholder="" v-model.trim="SJsearchFrom.driverName"></el-input>
            </el-form-item>
            <el-form-item label="身份证号:">
              <el-input placeholder="" v-model.trim="SJsearchFrom.idNumber"></el-input>
            </el-form-item>
            <el-form-item >
              <el-button type="primary" @click="SJsearchFn" >查询</el-button>
            </el-form-item>
            <el-form-item >
              <el-button type="primary" @click="resetForm('SJsearchFrom')">重置</el-button>
            </el-form-item>
          </div>
        </el-form>
        <div class="spry">
          <div class="tbox">
            <el-table :data="YYXQList" border ref="CDtable" highlight-current-row >
              <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
              <el-table-column prop="driverName" width="" label="司机姓名"></el-table-column>
              <el-table-column prop="idNumber" width="" label="身份证号"></el-table-column>
              <el-table-column prop="createTime" width="" :formatter="dateTimeFormat" label="摘单时间"></el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 分页 -->
        <div>
          <el-pagination background
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="SJsearchFrom.pageNo"
            :page-sizes="[10,25,50,100]"
            :page-size="SJsearchFrom.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="sjtotal">
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isEdit = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="司机端列表" :close-on-click-modal="false" :close-on-press-escape="false"  :visible.sync="sijiMark" width="750px" center>
      <div>
        <div class="spry">
          <div class="tbox">
            <el-table :data="sijiList" border ref="CDtable" highlight-current-row >
              <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
              <el-table-column prop="driverName" width="" label="司机姓名"></el-table-column>
              <el-table-column prop="mobile"  label="司机电话"></el-table-column>
              <el-table-column property="identityNo" label="司机身份证号" width="200">
                <template scope="scope">
                <p >
                  {{scope.row.idNumber.replace(/^(.{4})(?:\d+)(.{4})$/, "$1**********$2")}}
                </p>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sijiMark = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 指派司机多条 -->
    <el-dialog title="指派司机" :close-on-click-modal="false" :close-on-press-escape="false"  :visible.sync="zpsjMark" width="750px" center>
      <div>
        <div class="spry">
          <div class="tbox">
            <el-form  :inline="true"  :model="searchFrom2"  class="demo-form-inline"  label-width="80px"  size="mini"  >
              <el-form-item label="司机姓名">
                <el-input placeholder="" type="textarea" v-model="searchFrom2.driverName"  ></el-input>
              </el-form-item>
              <el-button type="primary" @click="searchFn2" >查询</el-button>
            </el-form>
            <el-table height="75vh" size="mini" ref="tabref" :data="tableList2" style="width:100%" border center  >
              <el-table-column type="selection" width="55" ></el-table-column>
              <el-table-column type="index"  label="序号" width="60"></el-table-column>
              <el-table-column prop="name"  label="司机姓名"></el-table-column>
              <el-table-column prop="mobile"  label="司机电话"></el-table-column>
              <el-table-column property="identityNo" label="司机身份证号" width="200">
                <template scope="scope">
                <p>
                  {{scope.row.identityNo.replace(/^(.{4})(?:\d+)(.{4})$/, "$1**********$2")}}
                </p>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination background @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
              :current-page="searchFrom2.pageNo" :page-sizes="[100, 200, 500]" :page-size="searchFrom2.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total2">
            </el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="zpsjMark = false">关闭</el-button>
        <el-button type="primary" @click="ZPsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 指派司机 -->
    <zhipaisiji v-if="zhipaiFlag" :rowData="row"  :zhipaiFlag.sync='zhipaiFlag'></zhipaisiji>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, encryption, dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import zhipaisiji from '@/views/newTMS/transportation/longGoods/zhipaisiji.vue'
import { cDlist, sourceList, sourceDelete, sourceStart, sourceStop, sourceFinish, takeRecordList, getSourceBinddingDrivers,
  getDictionaryDetailList, addOrDeleteBinddingDriver } from '@/api/newTMS'
export default {
  components: {
    zhipaisiji
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      initQCode: '',
      createTime: [],
      SJsearchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      idsj: '',
      YYXQList: [],
      isEdit: false,
      seeQuXiaoClick: false,
      emptyFn: emptyFn,
      isDisable: false,
      h: 500,
      searchFrom: {
        pageNo: 1,
        pageSize: 100
      },
      tableList: [],
      total: 0,
      sjtotal: 0,
      loading: false,
      btnFlg: [],
      btnIdArr: ['01N00D0100', '01N00D0200', '01N00D0300',
        '01N00D0400', '01N00D0500', '01N00D0600', '01N00D0700', '01N00D0800', '01N00D0900'],
      qrCodeInfo: {},
      row: {},
      zhipaiFlag: false,
      sijiList: [],
      sijiMark: false,
      HWlist: [],
      zpsjMark: false,
      tableList2: [],
      searchFrom2: { pageNo: 1,
        pageSize: 100 },
      total2: 0,
      orderInfo: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/longGoods')
    getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
    // this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    // 导出
    daochuFN () {
      let from = { ...this.searchFrom }
      delete from.pageNo
      delete from.pageSize
      exportExcel(
        this.global.tmsPlus + '/source/exportSourceList',
        from,
        '长期货源'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 司机端
    driverNumFn (row) {
      if (row.driverNum === 0) {
        this.$alert('该长期货源没有绑定司机', '系统提示')
        return
      }
      getSourceBinddingDrivers({
        'orderId': row.orderId,
        'orderNo': row.orderNo,
        driverName: this.searchFrom.driverName
      }).then(res => {
        this.sijiList = res
        this.sijiMark = true
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 指派司机
    zhipaiFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      if (selectData.length == 1) {
        this.row = selectData[0]
        this.zhipaiFlag = true
      } else {
        this.orderInfo = selectData.map(item => {
          return { 'orderId': item.orderId,
            'orderNo': item.orderNo }
        })
        cDlist(this.searchFrom2).then(res => {
          this.tableList2 = res.list
          this.total2 = res.total
          this.zpsjMark = true
        })
      }
    },
    ZPsaveFn () {
      let selectData = this.$refs.tabref.selection
      if (selectData.length == 0) {
        this.$alert('请选择至少选择一个司机', '系统提示')
      }
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      let addArr = selectData.map(item => {
        return {
          'driverId': item.id,
          'driverName': item.name,
          'idNumber': item.identityNo,
          'mobile': item.mobile
        }
      })
      addOrDeleteBinddingDriver({
        orderInfo: this.orderInfo,
        'addDrivers': addArr,
        'deleteDrivers': []
      }).then(res => {
        loading.close()
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.getList(this.searchFrom)
      }).catch(error => {
        loading.close()
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    searchFn2 () {
      if (this.searchFrom2.driverName) {
        this.searchFrom2.driverUserNames = this.searchFrom2.driverName.replace(/\n/g, ',')
      } else {
        this.searchFrom2.driverUserNames = ''
      }
      cDlist(this.searchFrom2).then(res => {
        this.tableList2 = res.list
        this.total2 = res.total
      })
    },
    // 每页条数
    handleSizeChange2 (val) {
      this.searchFrom2.pageSize = val
      this.searchFn2(this.searchFrom)
    },
    // 当前页
    handleCurrentChange2 (val) {
      this.searchFrom2.pageNo = val
      this.searchFn2()
    },
    // 每页条数
    handleSizeChange1 (val) {
      this.SJsearchFrom.pageSize = val
      this.SJsearchFn(this.SJsearchFrom)
    },
    // 当前页
    handleCurrentChange1 (val) {
      this.SJsearchFrom.pageNo = val
      this.SJsearchFn(this.SJsearchFrom)
    },
    // 停用、启用
    qiTingFN (row, n) {
      let str = ''
      if (n == 1) {
        str = '启用'
      } else {
        str = '停用'
      }
      this.$confirm('是否执行' + str + '操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        if (n == 1) {
          sourceStart({
            orderBusinessId: row.orderBusinessId
          }).then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          sourceStop({
            orderBusinessId: row.orderBusinessId
          }).then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      }).catch(() => {})
    },
    getAddress () {
      takeRecordList(this.SJsearchFrom).then(res => {
        this.YYXQList = res.list
        this.sjtotal = res.total
      })
    },
    // 查选
    SJsearchFn () {
      this.$set(this.SJsearchFrom, 'orderId', this.idsj)
      this.getAddress(this.SJsearchFrom)
    },
    numberFn (row) {
      this.isEdit = true
      this.$set(this.SJsearchFrom, 'orderId', row.orderId)
      this.$set(this, 'idsj', row.orderId)
      takeRecordList(this.SJsearchFrom).then(res => {
        this.YYXQList = res.list
        this.sjtotal = res.total
      })
    },
    addFn () {
      this.$router.push('/addchangqi')
    },
    // 查看
    lookFN (row) {
      this.seeQuXiaoClick = true
      let orderBusinessId = '' + row.orderBusinessId
      let orderId = '' + row.orderId
      let json = {
        orderBusinessId: orderBusinessId,
        orderId: orderId
      }
      let data = encryption({
        data: json,
        key: this.global.key,
        param: ['orderBusinessId', 'orderId']
      })
      this.initQCode = JSON.stringify(data)
      this.qrCodeInfo = row
    },
    // 删除
    delFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        // 停用、结束不能删
        let flagA = selectData.every(item => item.orderState == '1')
        console.log(flagA, 'flagA')
        if (flagA) {
          this.$alert('生效中状态数据不能删除', '系统提示')
          return
        }
        let orderId = []
        selectData.forEach(element => {
          orderId.push(element.orderId)
        })
        this.$confirm('是否执行删除操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          sourceDelete(orderId).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {})
      }
    },
    // 结束
    finishFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        let flagA = selectData.every(item => item.orderState != '2')
        console.log(flagA, 'flagA')
        if (!flagA) {
          this.$alert('不能选择已结束的数据', '系统提示')
          return
        }
        let orderBusinessId = []
        selectData.forEach(element => {
          orderBusinessId.push(element.orderBusinessId)
        })
        this.$confirm('是否执行结束操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          sourceFinish(orderBusinessId).then(res => {
            loading.close()
            this.$message({
              message: '结束成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {})
      }
    },
    // 编辑
    modifyFn (row) {
      this.$router.push({ name: 'addchangqi', query: { id: row.orderBusinessId } })
    },
    // 运单
    wayFn (row) {
      this.$router.push({ name: 'qiYunWay', query: { orderNo: row.orderNo } })
    },
    // 详情
    detailFn (row) {
      // this.$router.push({ name: 'CQgoodDetails', query: { id: row.id } })
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {},
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.tableList.toggleRowSelection(row)
    },
    // 获取货物列表
    getList (searchFrom) {
      this.$set(searchFrom, 'startTime', this.createTime[0])
      this.$set(searchFrom, 'endTime', this.createTime[1])
      sourceList(searchFrom).then(res => {
        console.log(res)
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    closeDialog () {
      this.$refs.tableList.clearSelection()
      this.SJsearchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    // 重置
    resetForm (formName) {
      this.SJsearchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.searchFrom = {
        pageNo: 1,
        pageSize: 100
      }
      this.createTime = []
    }
  },
  activated () {
    this.getList(this.searchFrom)
  },
  inject: ['reload'],
  beforeRouteEnter (to, from, next) {
    to.meta.keepAlive = true
    if (from.path !== '/addchangqi') {
      next(vm => {
        // vm.reload()
      })
    } else {
      next()
    }
    // next()
  },
  beforeRouteLeave (to, from, next) {
    if (to.path == '/addchangqi') {
      from.meta.keepAlive = true
    } else {
      from.meta.keepAlive = false
    }
    next()
  }
}
</script>
<style scoped lang='less'>
 .searchBox{
    display: flex;
 }
 .searchBox .el-date-editor{
   width: 350px!important;
 }
 /deep/.el-input.is-disabled .el-input__inner{
    border: none;
    background-color: #dcedff;
    color: #606266;
 }
 .box1 span{
   margin-left: 10px;
   font-size: 12px;
 }
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
